import * as React from 'react'
import { connect } from 'react-redux'
import { currentNavigationSelector } from '../selectors/navigation'
import { RootState } from '../types/rootstate'

interface StateProps {
  navigation: RootState['navigation']['navigationStacks']['key']
}

interface DispatchProps {
}

interface OwnProps {
  component: React.ComponentClass<any>
  path: string
}

type RouteProps = StateProps & DispatchProps & OwnProps

function mapStateToProps (state: RootState): StateProps {
  return {
    navigation: currentNavigationSelector(state)
  }
}

function mapDispatchToProps (dispatch): DispatchProps {
  return {}
}

interface RouteState {}

class RouteComponent extends React.Component<RouteProps, RouteState> {
  render () {
    const currentPathName = this.props.navigation &&
      this.props.navigation.currentIndex !== undefined &&
      this.props.navigation.history[this.props.navigation.currentIndex] &&
      this.props.navigation.history[this.props.navigation.currentIndex].name

    if (this.props.path === currentPathName) {
      const params = this.props.navigation.history[this.props.navigation.currentIndex].params
      return <this.props.component params={params} />
    }
    return null
  }
}

const Route = connect<StateProps, DispatchProps, OwnProps>(mapStateToProps, mapDispatchToProps)(RouteComponent)

export {
  Route
}
